export const TOOL_TYPE = {
  MCP: 'MCP',
  Other: 'Other',
} as const;

export type ToolType = (typeof TOOL_TYPE)[keyof typeof TOOL_TYPE];

export const TOOL_STATUS = {
  Active: 'Active',
  Inactive: 'Inactive',
  Error: 'Error',
} as const;

export type ToolStatus = (typeof TOOL_STATUS)[keyof typeof TOOL_STATUS];

/** Ordered list used to populate Type <Select> items. Add entries here to support new types. */
export const TOOL_TYPE_OPTIONS: { value: ToolType; label: string }[] = [
  { value: TOOL_TYPE.MCP, label: 'MCP' },
];

/** Ordered list used to populate Status <Select> items. */
export const TOOL_STATUS_OPTIONS: { value: ToolStatus; label: string }[] = [
  { value: TOOL_STATUS.Active, label: 'Active' },
  { value: TOOL_STATUS.Inactive, label: 'Inactive' },
];

export type MCPServerHTTPConfig = {
  transport: string;
  url: string;
  headers?: Record<string, string> | null;
  query_params?: Record<string, string> | null;
  timeout?: number;
  client_session_timeout_seconds?: number;
};

export type Tool = {
  id: string;
  name: string;
  description: string;
  type: ToolType;
  status: ToolStatus;
  enabled: boolean;
  config: MCPServerHTTPConfig | Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
};

export type ToolCreateRequest = {
  name: string;
  description: string;
  type: ToolType;
  status: ToolStatus;
  enabled: boolean;
  config: Record<string, unknown> | null;
};

export type ToolUpdateRequest = {
  name?: string;
  description?: string;
  status?: ToolStatus;
  enabled?: boolean;
  config?: Record<string, unknown> | null;
};

export type HeaderParam = {
  uid?: string;
  key: string;
  value: string;
};
